// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gray[data-v-6ddcea30] {\n  color: gray;\n}\n", ""]);
// Exports
module.exports = exports;
